/**
 * 报关贴纸管理- 贴纸审核 编辑页
 *
 * @author FJJ
 * @version 1.0
 * @Time 2025.02.25
 * @copyright 2021-2025, all rights reserved. Essa.cn
 */
import React from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import PageCommon from  "@components/PageCommon/PageCommon";
import { message,Modal,Result,Button,Drawer } from 'antd';
import Lang from "@components/Lang/Lang";
import OneItem from "./OneItem";
// import EssaModal from "@components/EssaModal/EssaModal";
import CustomsDeclarationStickerAction from "../../CustomsDeclarationSticker.action";
import { Spin} from "antd";
import {isEmpty,isEmptyObject} from '@utils/utils';
import dayjs from "dayjs";
import ImageHover from "../../Components/ImageHover";
import "./edit.less";
const config = require("@config/config");
class Edit extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            currItem:{},
            list:[],
            handleNum:0,
            modalVisible:false,
            nextTrackId:'',
            noHandleList:[],
            // 字典
            listTortDict:[]
        }
    }
    /**
     * 查看详情
     * @iId 订单号
     * @设置当前值
     * @成功后弹出 下一单窗口
     * */
    getDetail(iId='',iCurrInx=0, showSuccess=false){
        if(isEmpty(iId)){
            return
        }
        this.loading(true);
        const postData = {
            stickerAuditTaskId:iId,
        }
        CustomsDeclarationStickerAction.postHttpAction('/service/mg/sticker/audit/track/audit-detail',postData).then(res=>this.handleRes(res.data,iCurrInx,showSuccess)).catch(err=>this.handleRes(err))
    }
    handleRes(res,iCurrInx=0,showSuccess){
        const {success,valid,models,model} = res;
        if(success&&valid) {
            const nextTrackId = model && model.nextTrackId; // 下一单可处理ID
            this.setState({
                model:typeof model === 'object'?model:{},
                list:models,
                nextTrackId:nextTrackId
            })
            this.setSelectItem(iCurrInx,models[iCurrInx], showSuccess) //更新页面 设置选择
        }else if(res.message){
                message.warning(res.message);
                this.loading(false);
         } else this.loading(false);
    }
    // 设置页面 选择项
    setSelectItem(iCurrInx,currItem,showSuccess=false){
        // 处理当时读取项
        this.setState({
            currItem: currItem,
            currInx: iCurrInx,
            modalVisible:showSuccess,
        }, ()=>setTimeout(()=>this.loading(false), 400));

    }
    /**
     * 加载状态
     * */
    loading(flag,type=1) {
        if(type==2){
            this.setState({
                loadingPop: flag,
            });
        }else {
            this.setState({
                loading: flag,
            });
        }
    }
    /**
     * 按钮
     * */
    getCerId(str){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        this.setState({
            iId: iId
        })
        return iId;
    }
    /**
     * 关闭弹窗
     */
    setModalVisible(flag){
        this.setState({
            modalVisible:flag
        })
    }
    /**
    * 渲染下一单
     * @nextTrackId
    ***/
    renderNextDetail(nextTrackId){
        this.props.history.push('/customsDeclarationSticker/stickerReviewEdit?'+nextTrackId);
        this.setState({
            iId: nextTrackId
        },() =>this.getDetail(nextTrackId,0,false));
    }
    /**
     * 获取下一步
     * **/
    getNextOption(nextTrackId){
        let resBtn = [];
        if(!isEmpty(nextTrackId)) {
            resBtn.push(<Button type="primary" key="console" onClick={()=>this.renderNextDetail(nextTrackId)}>
                {Lang({id: "XiaYiDan",default: "下一单"})}
            </Button>)
        }else resBtn.push(<Button type="primary" key="console" onClick={()=>this.backList()}>
            {Lang({id: "GuanBi",default: "关闭"})}
        </Button>)
        return resBtn;
    }
    //返回列表
    backList(){
        this.loading(true);
        this.setModalVisible();
        setTimeout(()=>{
            this.props.history.push('/customsDeclarationSticker/stickerReview');
            this.loading(false);
        },400);
    }
    /**
     * 显示 修改贴纸窗口
     * */
    showPopEdit(flag=false){
        if(flag){
            this.loading(true,2);
            const { currItem={}} = this.state;
            CustomsDeclarationStickerAction.postHttpAction('/service/mg/sticker/audit/track/audit-update-detail',{
                poItemId:currItem.poItemId,
                poId: currItem.poId
            }).then(res=>this.handlePopRes(res.data,currItem)).catch(err=>this.handlePopRes(err,currItem));
        }else {
            this.setState({
                modelPop:{},
            })
        }
        this.setState({
            flagShowPopEdit:flag,
        })
    }

    handlePopRes(res,currItem){
        const {success,valid,models=[]} = res;
        if(success&&valid) {
            let item = models.length>0?models[0]:{}
            const stickerTemplateList = item.stickerTemplateList||[];
            if(item.stickerCode&&stickerTemplateList.length>0){
                const currItem = stickerTemplateList.find(siItem=>siItem.stickerCode==item.stickerCode);
                if(currItem&&currItem.stickerCode){// d贴纸模板 有效值 -> 在默认显示可选列表中才算有效，一般已选的会优选显示在此列
                    item.stickerItem = {
                        stickerCode:currItem.stickerCode
                    }
                }else {
                    item.stickerCode = "";
                    item.stickerItem = {
                        stickerCode:""
                    }
                }
            }else {
                item.stickerCode = "";
                item.stickerItem = {
                    stickerCode:""
                }
            }
            if(item.goodsCertificateList){
                for(let i = 0; i<item.goodsCertificateList.length; i++){
                    item.goodsCertificateList[i].id = item.goodsCertificateList[i].saleGoodsCertificateId;

                }
            }
            if(item.hasCertificate=== 1 && item.isFurnishCertificate === 0){
                item.hasCertificate = 2;
            }

           this.setState({
               modelPop:item
           })
        }else if(res.message){
            message.warning(res.message);
        }
        this.loading(false,2);
    }
    /**
     * 保存数据
     * @isSubmit  0 保存 1 提交
     * **/
    saveOther(data){
        this.setState({
            saveObj : data
        })
    }
    /**
     * 提交事件
     * @type 1 不通过提交， 2 通过提交，
     * @iId 当前处理Po单Id
     * @currItem 当前处理项
     * @isTort 是否侵权 0 正常 1 侵权
     * */
    onSaveGoods(type=2,item={}){
        const {iId,currItem={}} = this.state;
        let postData = {
            stickerAuditTaskItemId: currItem.stickerAuditTaskItemId
            };
        if(type==1){
            if(isEmptyObject(item)){
                message.warning(Lang({id: "MeiYouXiuGaiXiang",default: "没有修改项"}))
                return false
            }
            if (isEmpty(item.hasCertificate)){
                message.warning(Lang({id: "QingXuanZeShiFouYouShangPinZhengShu",default: "请选择是否有商品证书"}))
                return false
            }
            item.required = (item.hasCertificate==1 || item.hasCertificate==2)?true:false;// 有证书或者 无证书出货 时必填的内容校验用
            if (item.required&&isEmpty(item.customsCode)){
                message.warning(Lang({id: "QingShuRuHaiGuanBianMa",default: "请输入十位数的海关编码"}))
                return false
            }
            if (item.required&&isEmpty(item.stickerCode)) {
                message.warning(Lang({id: "XuanZeTieZhiMoBan",default: "选择贴纸模板"}))
                return false
            }
            if (item.required&&isEmpty(item.nameRu)) {
                message.warning(Lang({id: "SheZhiTieZhiPinPai",default: "设置贴纸品名"}))
                return false
            }
            // 1有证书时 必选 证书，0无证书必填 说明 ，2无证书出货可忽略
            if(item.hasCertificate === 0&&isEmpty(item.remark)){
                message.warning(Lang({id: "QingTianXieWuZhengShuShuoMing",default: "请填写无证书说明"}))
                return false
            }
            if(item.hasCertificate === 1&&(!item.goodsCertificateList || item.goodsCertificateList.length === 0)){
                message.warning(Lang({id: "NinShangWeiXuanZeZhengShu",default: "您尚未选择证书"}))
                return false
            }
            postData = {...postData,
                status: 20, // // 状态(20:审核不通过 30:审核通过)
                remark:item.remark,
                fileId:item.file&&item.file.length>0?item.file[0].fileId:null,
                trackItemList:{
                    customsCode:item.customsCode,
                    goodsDesc:item.goodsDesc,
                    nameRu:item.nameRu,
                    stickerCode:item.stickerCode,
                    trackItemId:item.trackItemId,
                    goodsCertificateList:item.goodsCertificateList,
                    hasCertificate: item.hasCertificate===2?1:item.hasCertificate, // 注意 此逻辑沿用 海关编码 设置的，选择了无证书出货 为2 需要重置 此两字段
                    isFurnishCertificate:item.hasCertificate === 2?0:(item.hasCertificate===1?1:-1),
                },
                // stickerAuditTaskItemId:iId
            }
        }else {
            postData = {...postData,
                status: 30, // 状态(20:审核不通过 30:审核通过)
                // stickerAuditTaskItemId:iId
            }
        }
        // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#8417
        this.loading(true);
        CustomsDeclarationStickerAction.postHttpAction('/service/mg/sticker/audit/track/audit-update-save',postData).then(res=>this.handleSubmitRes(res.data)).catch(err=>this.handleSubmitRes(err));
    }
    // 审核 回调
    handleSubmitRes(res){
        const {success,valid} = res;
        if(success&&valid) {
            this.showPopEdit(false)
            const {currInx=0,list=[] } = this.state;
            const nextInx = currInx+1;
            if(nextInx<list.length){
                this.setSelectItem(nextInx, list[nextInx],false) //更新页面 设置选择
            }else this.setSelectItem(nextInx, {},true) //更新页面 设置选择
        }else if(res.message){
            message.warning(res.message);
        }
        this.loading(false);
    }
    renderOne(currItem,key){
        return (<div className="stickerReviewEditStyle mb_16" key={key}>
            <div className={'top flex-item fw_500'}>
                <div className={"skuImg"}>
                    {currItem.skuPictureUrl?<img src={currItem.skuPictureUrl} alt={currItem.skuName} title={currItem.skuName} />:null}
                </div>
                <div className={"flex1 ml_12 black45"}>
                    <div>
                        <a className={"black66"} href={config.servers[config.environment].portalUrl+`/${currItem.skuId}.html?skuNo=${currItem.skuNo}`} target={'_blank'}>{currItem.skuName}</a>
                    </div>
                    <div className={"mt_12"}>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span className={"ml_12 black89"}>{currItem.skuNo}</span></div>

                    <div className={"rightInfo mt_12"}>
                        <div className={"flex-item"}>
                            <div className={"infoItemHalf"}><span className={"tit"}>{Lang({id: 'TieZhiPinMing', default: '贴纸品名'})}</span><span className={"black89"}>{currItem.nameRu}</span></div>
                            <div className={"infoItem"}><span className={"tit"}>{Lang({id: 'HaiGuanBianMa', default: '海关编码'})}</span><span className={"black89"}>{currItem.customsCode}</span></div>
                            <div className={"infoItem"}><span className={"tit"}>{Lang({id: 'TieZhiMoBan2', default: '贴纸模版'})}</span><span className={"black89"}>{currItem.stickerCode}</span></div>
                        </div>
                        <div className={"flex-item mt_12"}>
                            <div className={"infoItem"}><span className={"tit"}>{Lang({id: 'LeiMu', default: '类目'})}</span><span className={"black89"}>{currItem.categoryName}</span></div>
                            <div className={"infoItem"}><span className={"mr_12"}>{Lang({id: 'ZhuCaiZhi', default: '主材质'})}</span><span className={"black89"}>{currItem.mainMaterials}</span></div>
                            {/*<div className={"infoItem"}><span className={"tit"}>{Lang({id: 'BaoZhuangLeiXing', default: '包装类型'})}</span><span className={"black89"}>{currItem.skuNo}</span></div>*/}
                            {(currItem.attributeList||[]).map((item,index)=> <div className={"infoItem"} key={'att_'+index}><span className={"tit"}>{item.attributeName}</span>
                                {item.optionList&&item.optionList.length>0?item.optionList.map((opt,inx)=><span className={"black89"} key={"opt_"+inx}>{opt.optionName}</span>) :null}
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            {currItem.fileUrl||currItem.remark||(currItem.itemLogList&&currItem.itemLogList.length>0)?<div className={"mt_12 editInfo flex-item"}>
                {currItem.fileUrl&&<div className={"leftImg mr_12"}>
                    {/*<img src={currItem.fileUrl}  />*/}
                    <ImageHover src={currItem.fileUrl} height={90} />
                </div>}
                <div className={"flex1"}>
                    {currItem.itemLogList&&currItem.itemLogList.length>0?currItem.itemLogList.map((log,inx)=><div className={"font_14 fw_500"} key={"log_"+inx}>
                        <span className={"black45 title"}>
                            {/*{Lang({id: 'XiuGaiLeiXing', default: '修改类型'})}*/}
                            {log.typeName}
                        </span>
                        <span className={"black89 ml_8"}>
                            {log.valueAfter}
                        </span>
                    </div>):null}
                    <div className={"font_14 fw_500"}>
                        <span className={"black45 title"}>{Lang({id: 'XiuGaiShuoMing', default: '修改说明'})}</span>
                        <span className={"black89 ml_8"}>{currItem.remark}</span>
                    </div>
                    <div className={"font_14 fw_500"}>
                        <span className={"black45 title"}>{Lang({id: 'ShenHeRen', default: '审核人'})}</span>
                        <span className={"black89 ml_8"}>{currItem.auditName||"-"} <span className={"font_10 ml_2 mr_2"}>|</span> {currItem.auditTime?dayjs(currItem.auditTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</span>
                    </div>
                </div>
            </div>:null}
            {currItem.stickerLayoutFileList&&currItem.stickerLayoutFileList.length>0?<>
                {currItem.stickerLayoutFileList.map((pic,inx)=><div className={'content'} key={"pic"+inx}>
                    <img src={pic.fileUrl}  />
                </div>)}
            </>:null}
        </div>)
    }
    componentDidMount() {
        const { search,pathname } = this.props.location;
        let typePage = 0;
        if(pathname.indexOf("/stickerReviewDetail")!=-1){
            typePage = 0;
        }else if(pathname.indexOf("/stickerReviewEdit")!=-1){
            typePage = 1;
        }
        this.setState({
            canEdit:typePage
        })
        const iId = this.getCerId(search);
        this.getDetail(iId,0);
    }
    componentWillUnmount(){
        // window.removeEventListener('beforeunload', this.listener)
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { loading,currItem={}, modalVisible,nextTrackId,model, flagShowPopEdit,canEdit,modelPop,saveObj,iId,loadingPop,list=[]} = this.state;
        const currPageName = Lang({id: "TieZhiShenHe",default: "贴纸审核"});

        return (<PageCommon btnList={canEdit?[
            {
                btn: Lang({id:"XiuGai",default:"修改"}),
                icon:"ri-edit-line mr_4 color-yellow",
                btnClick:()=>this.showPopEdit(true)
            },{
                btn: Lang({id:"QueRen",default:"确认"}),
                icon:"ri-check-line color-green mr_4",
                btnClick:()=>this.onSaveGoods(2)
            }
        ]:[]}>
            <Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[
                    { name:currPageName,link:'/customsDeclarationSticker/stickerReview'},
                    {name:model&&model.poCode?model.poCode:''}
                    ]}></CommonBreadcrumb>
                {canEdit?this.renderOne(currItem,currItem.poItemId):list.map((curr,inx)=>this.renderOne(curr,curr.poItemId+"_"+inx))}

            {modalVisible&&<Modal
                open={modalVisible}
                footer={null}
                onCancel={()=>this.backList(false)}
            >
                <Result
                    status="success"
                    onCancel={()=>this.backList(false)}
                    title={Lang({id: 'GaiDingDanShangPinTieZhiY', default: '该订单商品贴纸已确认完成'})}
                    extra={this.getNextOption(nextTrackId)}
                />
            </Modal>}
                {flagShowPopEdit&&<Drawer open={flagShowPopEdit}
                                          width={1100}
                                          destroyOnClose={true}
                                          rootClassName={"stickerEditDrawerWrap"}
                                          onClose={()=>this.showPopEdit(false)}
                                          closeIcon={null}
                                          extra={<>
                                              <Button onClick={()=>this.showPopEdit(false)}>{Lang({id:'QuXiao',default:'取消'})}</Button>
                                              <Button onClick={()=>this.onSaveGoods(1,saveObj)} type={'primary'} className={"btnPinkPrimary ml_12"}>{Lang({id:'QueDing',default:'确定'})}</Button>
                                          </>}
                                          title={Lang({id: 'XiuGaiTieZhi', default: '修改贴纸'})}>
                    {!loadingPop?<OneItem item={modelPop}
                             isEdit={true}
                             key={"oneItem_"+0}
                             isSubmit={1}
                             saveOther={(data)=>this.saveOther(data,iId)}
                    />:null}
                </Drawer>}
        </Spin>
        </PageCommon>)
    }
}
export default Edit;
